import { useNavigate, useParams } from 'react-router-dom';
import { TableWidget } from '../../../components/table-widget/TableWidget';
import { useOperatorsState } from '../../../services/OperatorsList';
import { SummaryData } from '../../../interfaces/summary-data';
import { Button, ProgressBar, Table } from 'react-bootstrap';
import { useAuthState } from '../../../services/auth';
import { StringUtils } from '../../../util/string-utils';
import { Pagination } from '../../../components/pagination/pagination';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { any } from 'zod';
import './RoutersCpe.scss';
import { DevicesManaged } from '../../../components/operator-dashboard/devices-managed/DevicesManaged';
import { useTranslation } from 'react-i18next';

type Props = {
  summaryData: SummaryData;
};

const managedDevices = [
  ['Unknown', 0],
  ['Smartphone', 2],
  ['Laptops', 5],
  ['Desktops', 2],
  ['Tablets', 2],
  ['Wearable', 2],
  ['Smart Devices', 2],
  ['Smart TV', 3],
  ['Smart Speaker', 2],
  ['Games Console', 1],
  ['Printers', 1],
];

const emptyThreats = [
  ['Malware site blocked', 0],
  ['Spam generator site blocked', 0],
  ['File hosting site blocked', 0],
  ['Adware site blocked', 0],
  ['Command and Control server blocked', 0],
  ['Botnet site blocked', 0],
  ['Phishing site blocked', 0],
  ['App install blocked', 0],
];

export const RoutersCpe = (props: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { operatorList, loggedUserData } = useOperatorsState();
  const { operatorId, cpeId, id } = useParams();
  const { token, axiosInstance } = useAuthState();
  const [summaryData, setSummaryData] = useState<any>();
  const [deviceData, setDeviceData] = useState<any>();
  useEffect(() => {
    if (token) {
      fetchApi();
    }
  }, [token]);

  async function fetchApi() {
    // const data = await axios.get(`/op/${operatorId}/cpe/${cpeId}`);
    const data = await axios.get(`v2/op/router/${operatorId}/cpe/${cpeId}`);
    setSummaryData(data);
    const deviceApi = await axios.get(`v2/op/device/${operatorId}/device-categories/${cpeId}`);
    setDeviceData(deviceApi);
  }
  function identificationInfo() {
    const opId = loggedUserData?.operatorId;
    return [
      { key: opId === 4 || opId === 6 ? 'Mac address' : 'CPE Serial number', value: summaryData?.data?.serial, showUpdate: true },
      { key: 'CPE Mac address', value: summaryData?.data?.mac, showUpdate: true, show: opId !== 4 && opId !== 6 },
      //  { key: 'Registered to', value: summaryData?.data?.data?.registrant, showUpdate: true },
      { key: 'Verified', value: summaryData?.data?.dateVerified },
    ];
  }
  const fetchLogs = async (pageIndex: number, filterPage: string) => {
    const { data } = await axios.get(`op/${operatorId}/cpe_table/`);
  };
  function macInfo() {
    return [
      { key: 'MAC Address', value: summaryData?.data?.mac },
      { key: 'Serial Number', value: summaryData?.data?.serial },
    ];
  }

  function modelInfo() {
    return [
      { key: 'Manufacturer', value: summaryData?.data?.mac },
      { key: 'Model', value: summaryData?.data?.serial },
    ];
  }

  function timezoneAndFirmware() {
    return [
      { key: 'Timezone Offset', value: summaryData?.data?.time_zone_offset },
      { key: 'BlackDice ABC', value: summaryData?.data?.firmwareVersion || '-' },
    ];
  }

  function lastBootInfo() {
    return [
      { key: 'Last Reboot', value: summaryData?.data?.last_boot_local },
      { key: 'Last Seen At', value: summaryData?.data?.last_seen || '-' },
    ];
  }

  // function goToDevicePage(rowData: any, highlightCve?: boolean) {
  //   navigate(
  //     `/operators/${operatorId}/cpe/${cpeId}/d/${rowData.key.ID || rowData.key.deviceId}`,
  //     highlightCve ? { state: { id: 'high-cve' } } : undefined
  //   );
  // }

  function handleChange(checked: any) {
    console.log(checked);
    // this.setState({ checked });
  }
  // Percentage test

  const [totalThreatsMitigated, setTotalThreatsMitigated] = useState<number>(0);

  useEffect(() => {
    calculateTotalThreatsMitigated();
  }, [summaryData]);

  const calculateTotalThreatsMitigated = () => {
    const threatsArray = summaryData?.data?.threatArray || emptyThreats;
    const total = threatsArray.reduce((acc: number, curr: any) => acc + curr[1], 0);
    setTotalThreatsMitigated(total);
  };

  const getThreats = () => {
    return summaryData?.data?.threatArray?.length ? summaryData?.data?.threatArray : emptyThreats;
  };

  return (
    <section className={'w-full'}>
      <div className="flex w-full flex-col gap-5">
        {/* <TableWidget
          //onDelete={loggedUserData?.operatorId !== undefined && operatorId == loggedUserData?.operatorId ? deleteAction : null}
          hasSearch={true}
          url={`op/${operatorId}/cpe_table/`}
          //onRowSelect={goToCpePage}
          countPerPage={5}
        /> */}
        <div className="flex flex-col w-full bg-white rounded-2xl shadow-md p-1">
          <div className="flex items">
            <div className="flex flex-col w-full bg-white ">
              <Table bordered hover responsive>
                <thead>
                  <tr className="text-white text-center">
                    <th className="px-5 rounded-tl-lg">{t('cpeTabs.routers.status')}</th>
                    <th className="px-5 tl-lg">{t('cpeTabs.routers.accountId')}</th>
                    <th className="px-5 tl-lg">{t('cpeTabs.routers.macAddress')}</th>
                    <th className="px-5 tl-lg">{t('cpeTabs.routers.serialNumber')}</th>
                    <th className="px-5 tl-lg"> {t('cpeTabs.routers.version')}</th>
                    <th className="px-5 tl-lg">{t('cpeTabs.routers.lastReboot')}</th>
                    <th className="px-5 rounded-tr-lg">{t('cpeTabs.routers.lastSeenOn')}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // Render table only when routerTableData has a value
                    <tr className="text-center">
                      <td className="px-5 ">
                        <Button className="version-btn">{t('cpeTabs.routers.version')}</Button>{' '}
                      </td>
                      <td className="px-5">{summaryData?.data?.accountId}</td>
                      <td className="px-5">{summaryData?.data?.mac}</td>
                      <td className="px-5">{summaryData?.data?.serial}</td>
                      <td className="px-5">{summaryData?.data?.firmwareVersion}</td>
                      <td className="px-5">{summaryData?.data?.last_boot_local}</td>
                      <td className="px-5">{summaryData?.data?.last_seen}</td>
                    </tr>
                  }
                </tbody>
              </Table>
              {/* <div className="flex w-full justify-content-around align-items-center">
                <Pagination itemsPerPage={2} totalItems={2} paginate={fetchLogs} currentPage={1} />
              </div> */}
            </div>
          </div>
        </div>
        {/* <h3 className="total-results">Displaying 1 of 1</h3> */}
        <section className="md:contents lg:flex gap-5">
          <div style={{}} className="rounded-2xl shadow-md flex flex-col w-1/6 gap-1 p-4">
            <header>
              <h2 className="text-xl heading-cards font-medium">{t('cpeTabs.routers.routerInformation')}</h2>
            </header>

            <div className="flex flex-col gap-1 ml-3">
              <span className="router-info-heading ">{t('cpeTabs.routers.registrant')}</span>
              <span className="router-info font-semibold">{summaryData?.data?.registrant}</span>
            </div>

            <div className="flex flex-col gap-1 ml-3">
              <span className="router-info-heading ">{t('cpeTabs.routers.macAddress')}</span>
              <span className="router-info font-semibold">{summaryData?.data?.mac}</span>
            </div>

            <div className="flex flex-col gap-1 ml-3">
              <span className="router-info-heading ">{t('cpeTabs.routers.model')}</span>
              <span className="router-info font-semibold">{summaryData?.data?.serial}</span>
            </div>

            <div className="flex flex-col gap-1 ml-3">
              <span className="router-info-heading ">{t('cpeTabs.routers.serialNumber')}</span>
              <span className="router-info font-semibold">{summaryData?.data?.serial}</span>
            </div>

            <div className="flex flex-col gap-1 ml-3">
              <span className="router-info-heading ">{t('cpeTabs.routers.agentVersion')}</span>
              <span className="router-info font-semibold">{summaryData?.data?.firmwareVersion}</span>
            </div>
          </div>

          {/* <div style={{}} className="shadow-md flex flex-col grow p-8 rounded-lg border"> */}

          {/* <div style={{ height: '350px' }} className="flex flex-col flex-wrap rounded-lg">
              {managedDevices?.map((item: any, index: number) => (
                <div className="mt-3 flex flex-col gap-2 wrap w-16" key={item.key}>
                  <div className="text-white flex justify-between">
                    <span className="w-44 text-black font-medium">{item[0]}</span>
                    <span className="text-black font-medium">{item[1]}</span>
                  </div>
                  <ProgressBar style={{ height: '8px' }} now={item[1]*(5)} />
                </div>
              ))}
            </div> */}
          <div className="w-full h-[60%]">
            <DevicesManaged
              color={'#35B888'}
              title={t('cpeTabs.routers.devicesManaged')}
              devicesData={deviceData}
              linkUrl={`/general-list/${operatorId}/operatordevices/Total Devices Managed`}
            />
          </div>
          {/* </div> */}
        </section>

        {/* <BreakdownListNew
          color="rgb(0, 123, 255)"
          summaryData={props.summaryData}
          title="Router Information"
          vertical={true}
          customClass='w-full'
          subtitle="Account info"
          hideRegistrant={true}
          icon="/icons/bar-code-white.svg"
          dataArray={[macInfo(), modelInfo(), timezoneAndFirmware(), lastBootInfo()]}
        /> */}
      </div>
    </section>
  );
};
